var $       = require("jquery"),
    Project = require('./Project');

/**
 * Фабрика , создающая новый экземпляр проекта с заданной конфигурацией
 *
 * @function initProject
 * @for omjs
 * @param {String|Object} config - url конфигурации проекта или объект с конфигурацией
 * @static
 * @return {omjs.Project}
 */

module.exports = function(config){
    var result = $.Deferred(),
        project;

    if($.type(config) === 'string') {
        $.getJSON(config).done(function(confObject){
            project = new Project(confObject);
            result.resolve(project);
        });
    } else {
        project = new Project(config);
        result.resolve(project);
    }

    return result;
};


//////////////////
// WEBPACK FOOTER
// ./src/Project/fabric.js
// module id = 10
// module chunks = 0